export default __webpack_public_path__ + "static/media/p0.63ac3d1d.jpg";